<i18n
  src="@/locales/views/agro_exporter/production/query_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('list_processes')"
      :params="{
        agro_exporter_id: this.agro_exporter_id
      }"
    ></go-back-link>

    <template v-if="load_general_data">
      <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

      <tabs-container v-model="option_tabs" :with_routing="true" />

      <router-view
        :exportations="exportations"
        :containers="containers"
      ></router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/query_container_export/show_process.js";

export default {
  name: "AEProductionQueryContainerExportShowProcess",
  props: ["agro_exporter_process_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      agro_exporter_process: {},
      containers: [],
      exportations: [],
      option_tabs: []
    };
  },
  methods: {
    fetchData: async function () {
      await  this.fetchAgroExporterProcess();
      await this.fetchContainers();
      await this.fetchExportations();
      await this.fillOptions();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function() {
      let response = await Requester.fetchAgroExporterProcess(this.agro_exporter_process_id)
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers(
        this.agro_exporter_process_id,
        this.agro_exporter_id
      );
      this.containers = response.data;
    },
    fetchExportations: async function () {
      let response = await Requester.fetchExportations(
        this.agro_exporter_process_id,
        this.agro_exporter_id
      );
      this.exportations = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.exportations_title"),
          icon: "fa-solid fa-ship",
          route: { name: this.routeName("show_process_exportations") }
        },
        {
          name: this.$t("labels.containers_title"),
          icon: "fa-solid fa-truck-container",
          route: { name: this.routeName("show_process_containers") }
        },
        {
          name: this.$t("labels.schedule_title"),
          icon: "fa-solid fa-calendar-days",
          route: { name: this.routeName("show_process_schedule") }
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  }
};
</script>
